import '../src/scss/common.scss';

import '../src/js/common';
